import LanguageSelector from "./LanguageSelector"

export default LanguageSelector